<template>
    <div>
        <b-row>
            <!-- main -->
            <b-col cols="4">
                <h2>Просмотр компании</h2>
                <back-button :to="{name: 'Companies'}"/>

                <b-form @submit="onSubmit" size="sm">
                    <b-form-group
                            label="Название"
                    >
                        <b-form-input
                                v-model="company.title"
                                type="text"
                                required
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group label="Теги">
                        <tags v-bind:value="company.tags"
                              v-on:input="company.tags = $event"></tags>
                    </b-form-group>

                    <b-form-group label="ИНН">
                        <b-form-input
                                type="text"
                                v-model="company.inn"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group label="Сайт">
                        <b-form-input
                                type="text"
                                v-model="company.website"
                        ></b-form-input>
                    </b-form-group>

                    <b-form-group label="Контакты:">
                        <contacts v-model="company.contacts" v-on:input="company.contacts=$event"></contacts>
                    </b-form-group>

                    <br/>

                    <loading-button :is-busy="isBusy"></loading-button>
                </b-form>
            </b-col>
            <!-- comments -->
            <b-col cols="8" class="comments-box">
                <comments :entity="company" entity-type="company"></comments>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import Tags from "../components/tags";
    import Contacts from "../components/ContactsAssignable";
    import LoadingButton from "../components/LoadingButton";
    import BackButton from "../components/BackButton";
    import Comments from "../components/Comments";

    export default {
        name: "Company",
        components: {Comments, BackButton, LoadingButton, Contacts, Tags},
        data() {
            return {
                isBusy: false,
                totalRows: 1,
                errorResult: null,
                messageResult: '',
                perPage: 20,
                currentPage: 1,
                error: false,
                message: '',
                items: [],
                company: {
                    title: '',
                    inn: '',
                    website: '',
                    tags: []
                }
            }
        },
        mounted() {
            this.fetchCompany();
        },
        methods: {
            fetchCompany() {
                this.error = false;
                this.isBusy = true;
                this.axios.get(process.env.VUE_APP_BACKEND_URL + '/api/companies/' + this.$route.params.id, {}
                ).then((response) => {
                    if (response) {
                        if (response.data.error === false) {
                            this.error = false;
                            this.company = response.data.company
                            if (this.company.tags === null || this.company.tags === undefined) {
                                this.company.tags = [];
                            }
                            this.isBusy = false;
                        } else {
                            this.error = true;
                            this.message = response.data.message;
                            this.isBusy = false;
                        }
                    }
                })
            },
            submitSearch() {

            },
            onSubmit(evt) {
                evt.preventDefault();
                this.error = false;
                this.isBusy = true;
                this.axios.post(process.env.VUE_APP_BACKEND_URL + '/api/companies/' + this.company.id, JSON.stringify(this.company)
                ).then((response) => {
                    this.isBusy = false;
                    if (response) {
                        if (response.data.error === false) {
                            this.error = false;

                        } else {
                            this.error = true;
                            this.message = response.data.message;
                        }
                    }
                });
            },
        }
    }
</script>

<style scoped type="scss">
    .comments-box {
        height: 100vh;
        border-left: 1px solid #ccc;
    }
</style>
